import { render, staticRenderFns } from "./SearchItem.vue?vue&type=template&id=70434b11&scoped=true"
import script from "./SearchItem.vue?vue&type=script&lang=ts"
export * from "./SearchItem.vue?vue&type=script&lang=ts"
import style0 from "./SearchItem.vue?vue&type=style&index=0&id=70434b11&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70434b11",
  null
  
)

export default component.exports